import de from '@translations/de/noResults.json';
import en from '@translations/en/noResults.json';
import pl from '@translations/pl/noResults.json';
import sl from '@translations/sl/noResults.json';
import uk from '@translations/uk/noResults.json';
import bg from '@translations/bg/noResults.json';
import cz from '@translations/cz/noResults.json';
import fr from '@translations/fr/noResults.json';
import gr from '@translations/gr/noResults.json';
import it from '@translations/it/noResults.json';
import pr from '@translations/pr/noResults.json';
import ru from '@translations/ru/noResults.json';
import sk from '@translations/sk/noResults.json';
import sp from '@translations/sp/noResults.json';
import tr from '@translations/tr/noResults.json';
import hu from '@translations/hu/noResults.json';
import { ITranslations } from '@/types/common';
import { NoResultsTransFields } from './types';

export const noResultsTranslations: ITranslations<NoResultsTransFields> = {
  name: 'noResults',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
